import Marquee from "react-fast-marquee";

const items = [
  "Empowering Bhubaneswar",
  "Global Careers",
  "AI Innovation",
  "Lifelong Learning",
  "Study Abroad",
  "Future-Ready Skills",
];

export default function EditorialMarquee() {
  return (
    <section className="border-y border-border/60 bg-sand/40 py-6 overflow-hidden" data-testid="marquee">
      <Marquee speed={45} gradient={false} autoFill>
        {items.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display text-3xl sm:text-5xl text-secondary/90 px-8 tracking-tight">
              {t}
            </span>
            <span className="text-primary text-2xl sm:text-3xl">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
